<div *ngIf="visualizations && visualizations.length">
  <div *ngFor="let el of visualizations">
    <app-viz-plotly [id]="el.id" [data]="el.data" [layout]="el.layout" *ngIf="el.vizType === VizType.Plot">
    </app-viz-plotly>
  </div>
</div>